module.exports = __webpack_public_path__ + "static/media/empty_list.e76fda82.svg";